export const minLength = 3;
export const maxLength = 256;
export const tagMinLength = 1;
export const tagMaxLength = 256;
export const stringPattern = '^[A-Za-z0-9 _]+$';
export const emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-z0-9.-]+\\.[a-zA-Z]{2,}';

// export const stringPattern = '^[a-zA-Z0-9_][a-zA-Z0-9_ ]*[a-zA-Z0-9_]$';
export const numberPattern = '^[A-Za-z0-9 _]+$';
export const minItems = 1;
export const urlPattern =
  '(https://www.|http://www.|https://|http://)?[a-zA-Z0-9]{2,}(.[a-zA-Z0-9]{2,})(.[a-zA-Z0-9]{2,})?/[a-zA-Z0-9]{2,}';

// Custom Error Msg
export const stringPatternError = 'Special characters are not allowed!';
export const emailPatternError = 'Enter a valid email address';

export const generatePassword = () => {
  const length = 10;
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let password = '';
  for (let i = 0; i <= length; i++) {
    const index = Math.floor(Math.random() * charset.length);
    password += charset[index];
  }
  return password;
};

//password validation
export const passwordValidationPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
export const passwordValidationPatternError = 'Password must meet the requirements';
